import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LeadsService } from '@features/leads/services/leads.service';
import { OpportunitiesService } from '@features/opportunities/services/opportunities.service';
import { NextStep } from '@shared/models/next-step';
import { DrawerModalService } from '@shared/services/drawer-modal.service';
import moment from 'moment';

@Component({
  selector: 'app-next-step-item',
  templateUrl: './next-step-item.component.html',
  styleUrl: './next-step-item.component.scss',
  standalone: false,
})
export class NextStepItemComponent implements OnInit {
  @Input() nextStep: NextStep;
  @Input() showLink: boolean = false;
  @Input() modalView: boolean = false;
  isOverdue = false;
  isDueSoon = false;

  constructor(
    private router: Router,
    private opportunitiesService: OpportunitiesService,
    private leadsService: LeadsService,
    private drawerModalService: DrawerModalService,
  ) {}

  ngOnInit(): void {
    const remainingDays = moment(this.nextStep.attributes.due_date)
      .startOf('day')
      .diff(moment().startOf('day'), 'days');
    this.isDueSoon = remainingDays >= 0 && remainingDays <= 7;
    this.isOverdue = remainingDays < 0;
  }

  navigateToOpportunity(event: any) {
    event.stopPropagation();
    this.opportunitiesService.setOpportunityFilters({ id: [this.nextStep.attributes.opportunity_id!] });
    this.router.navigateByUrl('/orders-and-opportunities/opportunities');
    this.closeModal();
  }

  navigateToLead(event: any) {
    event.stopPropagation();
    this.leadsService.setLeadFilters({ id: [this.nextStep.attributes.lead_id!] });
    this.router.navigateByUrl('/orders-and-opportunities/leads');
    this.closeModal();
  }

  closeModal() {
    if (this.modalView) this.drawerModalService.dismissModal();
  }
}
